import $ from 'jquery'

if (document.getElementById('page-service')) {
  // #page-topがあるページだけで実行
  page()
}

function page() {
  /**
   * 料金表タブ
   */
  $('.js-price-tab').on('click', function () {
    const $self = $(this)
    const id = $self.data('id')

    $('.js-price-tab').removeClass('is-current')
    $self.addClass('is-current')

    $('.js-price-tab-content').removeClass('is-current')
    $(`.js-price-tab-content[data-id="${id}"]`).addClass('is-current')
  })

  /**
   * プロセス
   */
  const $bar = $('.js-process-bar')
  const $progress = $('.js-process-progress')
  let heightCurrent = 0
  $(window).on('load scroll resize', () => {
    const point = $(window).scrollTop() + $(window).height() * 0.7

    const heightMax = $bar.height()
    const height = Math.max(heightCurrent, Math.min(point - $bar.offset().top, heightMax))
    heightCurrent = height
    $progress.height(height)

    $('.serviceProcess__listBody:not(.is-show)').each(function () {
      const $self = $(this)
      const line = $(window).width() > 768 ? $self.outerHeight() / 2 : (29 / 390) * $(window).width()
      const triggerPoint = $self.offset().top + line

      if (triggerPoint <= point) {
        $self.addClass('is-show')
      }
    })
  })
}
